/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row } from 'antd';

import { Typography } from '@components/atoms';
import { postBy, formatArticleError } from '@utils';
import { DeleteButton, InfoItem } from '@molecules';
import { useVideo } from '@api/hooks';

const VideoItem = ({ video, onDelete }) => {
  if (video instanceof Error) {
    const error = video;
    return <InfoItem>{formatArticleError(error)}</InfoItem>;
  }

  return (
    <InfoItem description={postBy(video)} extra={<DeleteButton onDelete={onDelete} />}>
      {video.title}
    </InfoItem>
  );
};

const VideoList = ({ videoId, onDelete }) => {
  const { data: video } = useVideo({ id: videoId });

  if (!video) return <>loading...</>;

  return (
    <Row style={{ display: 'block' }}>
      <Row align="middle" justify="space-between">
        <Typography.Title level={3}>Current video</Typography.Title>
      </Row>

      <VideoItem video={video} onDelete={onDelete} />
    </Row>
  );
};

export default VideoList;
